import React, { useEffect, useRef } from "react";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sessionId) { window.location.href = window.location.pathname; return; }

    const finish = () => { window.location.href = window.location.pathname; };

    fetch(`${API_URL}/api/auth/reader/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then(() => {
        const guest = JSON.parse(localStorage.getItem("mm-guest") || "{}");
        const hasGuestState = (guest.bookmarks?.length || 0) + (guest.likes?.length || 0) > 0;
        if (!hasGuestState) { finish(); return; }
        fetch(`${API_URL}/api/reader/merge`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ bookmarks: guest.bookmarks || [], likes: guest.likes || [] }),
        })
          .then(() => { localStorage.removeItem("mm-guest"); })
          .finally(finish);
      })
      .catch(() => {
        toast.error("Google sign-in could not be completed. Please try again.");
        finish();
      });
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#FBF9F5] text-[#1F2328]">
      <div className="w-10 h-10 rounded-full bg-[#B85D34] text-white flex items-center justify-center font-serif text-xl shadow-md">M</div>
      <p className="font-serif text-xl opacity-70 animate-pulse">Opening your reader's key...</p>
    </div>
  );
}
